import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription, interval, lastValueFrom } from 'rxjs';
import { MessagesService } from '@core/_services/messages.service';
import { ApiV6Service } from './apiv6.service';
import { dateFormat } from '@core/_utils/date.utils';
import { clearStorage, getDataFromStorage, getParseToken, isInArrayKey, storeData } from '@core/_utils/tools.utils';
import { Router } from '@angular/router';
import { DownloadService } from './download.service';

@Injectable()
export class NotificationService {
    public execTimer: any;
    public timerSubcribe: Subscription;
    public notifyInfo = [];
    public notifList = [];
    public notifyCount = 0; 

    // Type de notification :
    // 0 : Statistiques disponibles
    // 1 : Pdfs disponibles
    // 2 : Copies zip disponibles
    // 3 : Originaux zip disponibles
    // 4 : Message de (lié à un document)
    // 5 : Zdocs disponibles
    // 6 : Message
    // 7 : Echec

    // Etat notification statenotif :
    // 0 : nouvelle
    // 1 : rejetée
    // 2 : aquitée 
    // 3 : terminée
    // 7 : échec

    constructor(private api: ApiV6Service, private _messageService: MessagesService, private _translate: TranslateService,
        private router: Router,
        private downloadService: DownloadService) {
        this.notifyInfo = new Array();                
    };

    public destroy() {
        if (this.timerSubcribe !== null && this.timerSubcribe !== undefined) {
            this.timerSubcribe.unsubscribe();
        }
    }

    public initialize() {
        this.timerSubcribe = null;
        this.execTimer = interval(60000);
        this.timerExecSubcribe();
        this.getNotifyInfos();
    }

    public setNotifyList(aData) {
        this.notifList = aData.data;
    }

    private timerExecSubcribe() {
        this.timerSubcribe = this.execTimer.subscribe(
            (data) => this.timerExecute(data),
            (error) => this.errorTimer(error)
        );
    }

    private async timerExecute(aData) {
        let wRes: any = {};
        const token = getParseToken();
        if (token) {
            try {
                wRes = await lastValueFrom(this.api.execUrlAction('getnotiflist', ''));
                this.notify(wRes.data);	
            } catch (error) {
                console.log('NotificationService timerExecute error', error);
                this.timerSubcribe.unsubscribe();
                if (error.status === 401) {
                    this.router.navigate(['expired']);
                } else {
                    this.router.navigate(['page-error']);
                }
            }
        }
    }

    public updateStoreList(aId) {
        let wNotif = [];
        // Récup notifications actuelles
        wNotif = getDataFromStorage('notifylist');
        wNotif = wNotif.filter(item => {
            return item.id !== aId;
        });
        storeData('notifylist', JSON.stringify(wNotif));
    }

    private notify(aRes) {
        let wNotif = [];
        let wNewNotif = [];
        let wNotifNotCheck = [];
        let wRes;        
        this.notifyCount = 0;
        // Récup notifications actuelles
        wNotif = getDataFromStorage('notifylist');    
        // Ajout des nouvelles notifications
        aRes.forEach(item => {
            this._messageService.addNotify(this.getFormatMessage(item),
            {
                idNotif : item.id,
                typeNotif: item.typenotif,
                stateNotif: item.statenotif
            });
            wRes = isInArrayKey(item.id, wNotif, 'id');
            if (wRes === undefined) {
                wNewNotif.push(item);
            }
        });
        if (wNewNotif.length !== 0) {
            const wMerged = [...wNotif, ...wNewNotif];
            storeData('notifylist', JSON.stringify(wMerged));
            this.notifyCount = wMerged.length;
        } else {
            wNotifNotCheck = wNotif.filter(item => {
                return item.statenotif === 0;
            });
            this.notifyCount = wNotifNotCheck.length;
        }        
    }

    private getFormatMessage(aData) {
        let wMess = '';
        // Echec de la demande
        if (aData.statenotif === 7) {
            wMess = this.getOriTypeNotif(aData.typenotif);  
            wMess += '\n' + dateFormat(aData.datenotif, ' (dd/MM/yyyy HH:mm:ss)');
        } else {
            wMess = this.notifyInfo[aData.typenotif];
            switch (aData.typenotif) {
                case 4:
                case 6:
                    wMess += aData.datanotif + '\n' + dateFormat(aData.datenotif, ' (dd/MM/yyyy HH:mm:ss)');
                    break;
                default:
                    wMess += dateFormat(aData.datenotif, ' (dd/MM/yyyy HH:mm:ss)');
                    break;
            }     
        }
        return wMess;    
    }

    private getOriTypeNotif(aTypenotif) {
        switch (aTypenotif) {
            case 0:
                return this.notifyInfo[7];
            case 1:
                return this.notifyInfo[8];                    
            case 2:
                return this.notifyInfo[9];                    
            case 3:
                return this.notifyInfo[10];                    
            case 4:
                return this.notifyInfo[11];                    
        }          
    }

    private errorTimer(aError) {
        console.log('PageBasketListComponent errorTimer', aError);
    }
  
    public async rejectNotify(aData) {
        let wRes: any = {};
        wRes = await this.updateState(aData, 1);
    }

    public async endNotify(aData) {
        let wRes: any = {};
        wRes = await this.updateState(aData.id, 3);
    }

    public async confirmNotify(aData) {
        let wRes: any = {};
        wRes = await this.updateState(aData, 2);
        if (wRes.Status === 'ERROR')  {
            return;
        }
        wRes = await this.execAction(wRes);        
    }

    private async execAction(aData) {
        let wRes: any = {};
        switch (aData.typenotif) {
            case 0:
            case 1:
            case 2:
            case 3:
            case 5:
            {   // pdf, stat
                await this.execDownLoad(aData)              
                break;
            }
            case 4: 
            case 7: 
            case 6:{
                // message
                break;
            }
        }
    }

    private async execDownLoad(aData) {
        let wtype;
        let filename = aData.datanotif;
        let wRequest = {
            BatchResult: true,
            BatchName: aData.datanotif,
        };    
        await this.downloadService.downLoadBatch(wRequest, wtype, filename);
    }

    public async addNotification(aData) {
        let wRes: any = {};
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('addnotif', aData));
            wRes = {Status: 'OK'};
        } catch (error) {
            console.log(error);
            wRes = {Status: 'ERROR'};
        }
        return wRes;
    }

    private async updateState(aId, aState) {
        let wRes: any = {};
        const wData = {
            id: aId,
            statenotif: aState
        }
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('updatenotif', wData));
            wRes.Status = 'OK';
        } catch (error) {
            this._messageService.addErrorMsg(this._translate.instant('Update_KO'));
            wRes = {Status: 'ERROR'};
        }
        return wRes;
    }

    public async deleteNotify(aId) {
        let wRes: any = {};
        const wData = {
            id: aId,
        }
        try {
            wRes = await lastValueFrom(this.api.execUrlAction('deletenotif', wData));
        } catch (error) {
            this._messageService.addErrorMsg(this._translate.instant('Update_KO'));
        }
        return wRes;
    }    

    public getFromUser(aIsAdmin, aUserList, aCurrentUser)  {
        const normalizedName = aCurrentUser.toUpperCase();
        if (aIsAdmin === true) {
            return 'Administrateur'
        } else {
            for (const item of aUserList) {
                if (item.retCode.toUpperCase() === normalizedName) {
                    return item.displayValue;
                }
            }
        }
    }

    public getDestUser(aDestUser, aUserList) {
        const normalizedName = aDestUser.toUpperCase();
        if (aDestUser === 'Administrateur' || aDestUser.toLowerCase() === 'admin') {
            return {
                displayValue: 'Administrateur',
                retCode: 'admin'
            }
        } else {
            for (const item of aUserList) {
                if (item.retCode.toUpperCase() === normalizedName) {
                    return item;
                }
            }
        }
    }

    private getNotifyInfos() {
        if (this.notifyInfo.length === 0) {
            this.notifyInfo.push(this._translate.instant('Notify_Type_0'));
            this.notifyInfo.push(this._translate.instant('Notify_Type_1'));
            this.notifyInfo.push(this._translate.instant('Notify_Type_2'));
            this.notifyInfo.push(this._translate.instant('Notify_Type_3'));
            this.notifyInfo.push(this._translate.instant('Notify_Type_4'));
            this.notifyInfo.push(this._translate.instant('Notify_Type_5'));
            this.notifyInfo.push(this._translate.instant('Notify_Type_6'));
            this.notifyInfo.push(this._translate.instant('Notify_Type_7'));            
            this.notifyInfo.push(this._translate.instant('Notify_Type_8'));            
            this.notifyInfo.push(this._translate.instant('Notify_Type_9'));
            this.notifyInfo.push(this._translate.instant('Notify_Type_10'));
            this.notifyInfo.push(this._translate.instant('Notify_Type_11'));
        }
    }
}
